import { useNavigate, useLocation } from "react-router-dom";
import { Home } from "lucide-react";
import { motion } from "framer-motion";

/**
 * Floating Home Button - provides navigation back to home on pages without bottom nav.
 * Hidden on immersive cinematic experiences to preserve aesthetic.
 */
const FloatingHomeButton = ({ className = "" }) => {
  const navigate = useNavigate();
  const location = useLocation();

  // Hide on immersive experiences + public share pages
  const hideOnRoutes = [
    "/golf/coach",
    "/soulumo/from",
    "/soulumo/coach",
    "/atelier/guide",
    "/gym/guide",
    "/networker/guide",
    "/foundations/guide",
    "/lights/guide",
    "/soulumo/guide",
    "/inner-path/guide",
    '/abundance/living-vision-board',
    '/healing',
    '/journeys',
    '/gift-moment',
    '/share/audio',
    '/gift/',
    '/listen',
    '/living-dream',
    '/atelier',
    '/gift/atelier',
    '/rewrite',
    '/golf/reclaim-the-shot',
    '/clearing/reclaim-the-pattern',
    '/abundance/rewrite-scarcity',
    '/presence/return-to-here',
    '/relationships/rewrite-the-armour',
    '/performance/free-under-pressure',
    '/inner-path/deep/',
    '/inner-path/daily/',
    '/inner-path/morning-arrival',
  ];
  if (hideOnRoutes.some(r => location.pathname.startsWith(r))) return null;

  return (
    <motion.button
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.95 }}
      onClick={() => navigate("/reclaim-home")}
      className={`fixed bottom-6 left-6 z-50 w-12 h-12 rounded-full bg-white/10 backdrop-blur-sm border border-white/20 flex items-center justify-center shadow-lg hover:bg-white/20 transition-colors ${className}`}
      data-testid="floating-home-btn"
    >
      <Home size={20} className="text-white/80" />
    </motion.button>
  );
};

export default FloatingHomeButton;
